import { takeLatest, put, call } from 'redux-saga/effects';

import { listFornecedorCadastro } from '../service';
import {
  TABLE_FORNECEDOR_CADASTRO,
  TABLE_FORNECEDOR_CADASTRO_PENDING,
  TABLE_FORNECEDOR_CADASTRO_SUCCESS,
  TABLE_FORNECEDOR_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListFornecedorCadastro(action) {
  yield put({ type: TABLE_FORNECEDOR_CADASTRO_PENDING })

  try {
    const table = yield call(listFornecedorCadastro, action.args)
    yield put({ type: TABLE_FORNECEDOR_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_FORNECEDOR_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListFornecedorCadastro() {
  yield takeLatest(TABLE_FORNECEDOR_CADASTRO, sagaListFornecedorCadastro)
}